// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"ContextMenu_dropdownMenu__1hqOc"};